import styles from './footer.module.scss';
import Link from 'next/link';
import useScreenWidthBelowThreshold from '@/hooks/useScreenWidthBelowThreshold';

export default function Footer() {
  const isScreenWidthBelow700px = useScreenWidthBelowThreshold(700);

  // if (isScreenWidthBelow700px) {
  //   return null;
  // } else {
  return (
    <div className={styles.footer}>
      <div className={styles.terms}>
        <Link href="/wing/privacy" target="_blank">
          Privacy
        </Link>
        <Link href="/wing/terms" target="_blank">
          Terms
        </Link>
      </div>
      <div className={styles.text}>Copyright © 2026 WINK TECHNOLOGY PTE. LTD All Rights Reserved.</div>
    </div>
  );
}
// }
